import { c as _c } from "react/compiler-runtime";
import { SEOMetadata, SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
import { ContentTrack } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
export const ContentTrackSEO = props => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const seoProps = {};
    t0 = <><SEOMetadata {...seoProps} /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
ContentTrackSEO.fragments = {
  ContentTrack: () => gql`
    fragment _ on ContentTrack {
      id
    }
  `
};